module.exports = __webpack_public_path__ + "static/media/game-cloud-logo.4d6a301e.png";